import { create } from "zustand"
import { persist } from "zustand/middleware"

interface UseSideNavStoreState {
  isCollapsed: boolean
  toggleCollapsed: () => void
}

export const useSideNavStore = create<UseSideNavStoreState>()(
  persist(
    (set) => ({
      isCollapsed: false,
      toggleCollapsed: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
    }),
    { name: "sidenav-state" }
  )
)
